<template>
    <div>
        <buttonlist @reflash="reflash" @help="help"
                    ref="SetBtn"></buttonlist>
        <div class="btnnowrap" style="margin-top: 2px">
            <el-button type="primary"  size="mini" @click="schQuotation(1)" :disabled="!btn.operate">{{$t('getapi[6187]')}}</el-button>
            <el-button type="primary"  size="mini" @click="reject" :disabled="!btn.operate">{{$t('getapi[6228]')}}</el-button>
        </div>
        <el-table
                id="xpane-0"
                :data="dataDetail.DTlines"
                ref="singleTable"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                @selection-change="handleSelectionChange"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%;"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column  prop="part_code" :label="$t('getapi[112]')" width="150" sortable="custom"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="PriceRemark" :label="$t('getapi[7973]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="PriceRemark2" :label="$t('getapi[12608]')" width="70" v-if="userData.Login_DB == 'MLXY'">
            </el-table-column>
            <el-table-column prop="Old_Unit_Price" :label="$t('getapi[6442]')" width="60" align="right">
                <template slot-scope="scope">
                    {{scope.row.Old_Unit_Price | thousandth}}
                </template>
            </el-table-column>
            <el-table-column :label="$t('getapi[8172]')" width="70">
                <template slot-scope="scope" v-if="scope.row.New_Unit_Price && scope.row.Old_Unit_Price">
                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) >= 0" style="color: red">{{getRiseAndFallRate(scope.row)}}%</span>
                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) < 0" style="color: #67C23A">{{Math.abs(getRiseAndFallRate(scope.row))}}%</span>
                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.New_Unit_Price / scope.row.Old_Unit_Price * 10000) / 100.00) - 100).toFixed(2)}}%</span>
                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.net_price / scope.row.Old_Unit_Price * 10000) / 100.00) - 100).toFixed(2)}}%</span>
                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs( scope.row.Old_Unit_Price - scope.row.New_Unit_Price)/ scope.row.New_Unit_Price * 10000) / 100.00).toFixed(2)}}%</span>
                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs(scope.row.Old_Unit_Price - scope.row.net_price) / scope.row.net_price * 10000) / 100.00).toFixed(2)}}%</span>
                </template>
            </el-table-column>
            <el-table-column prop="New_Unit_Price" :label="$t('getapi[1410]')" width="70">
                <template slot-scope="scope">
                    {{scope.row.New_Unit_Price | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="MOQ" label="MOQ" width="70" align="right">
                <template slot-scope="scope">
                    {{scope.row.MOQ | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="net_price" :label="$t('getapi[6732]')" width="100" align="right">
                <template slot-scope="scope">
                    {{scope.row.net_price | thousandth}}
                </template>
            </el-table-column>
            <el-table-column prop="batch_floor_limit" label="MOQ2" width="70" align="right">
                <template slot-scope="scope">
                    {{scope.row.batch_floor_limit | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="Process_Remark" :label="$t('getapi[6702]')" width="120"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Area" :label="$t('getapi[139]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Shipment_Cycle" :label="$t('getapi[6736]')" width="80" align="right">
                <template slot-scope="scope">
                    {{scope.row.Shipment_Cycle | thousandth}}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="PriceEffective_Date" :label="$t('getapi[1339]')" width="100"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Routing_Name" :label="$t('getapi[881]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1287]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Item_Name" :label="$t('getapi[546]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[876]')" width="70"></el-table-column>
            <el-table-column show-overflow-tooltip prop="Remarks" :label="$t('getapi[143]')" width="70"></el-table-column>
        </el-table>
        <el-dialog v-dialogDrag :title="$t('getapi[6472]')" :visible.sync="CloseDialogVisible" width="30%">
            <el-input type="textarea" :rows="5" v-model="resontxt"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="schQuotation(2)">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
    export default {
        name: 'wxpricereqapprove',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3 - Common.reduceTableHeight3
            }
        },
        data() {
            return {
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user:[],
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false, // 主表加载状态
                dataDetail:{
                    IsEdit:1,
                    Master:{},
                    DTAuditInfo:[],
                    DTlines:[]
                },
                CloseDialogVisible: false,
                resontxt: '',
                btn: {
                    operate: false
                },
                scrollTop:0,
                changeRateArr:[],
            };
        },
        mounted: function () {
            let that = this;
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            //that.authority();
            that.$limits.dragControllerDiv();
            that.getExchangeRate()
            that.getView()
            that.authority()
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6562]"),this.$t("getapi[13]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('refresh');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.operate = false
                if(that.selectData.length > 0){
                    that.btn.operate = true
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let parm = {
                    AuditPerson: that.user
                }
                that.$http.urlpost('/ISS/PQAudit/ISSQAuditInfoByAudit', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail.DTlines = res.DataContent.DTlines
                        that.loading = false;
                        that.$nextTick(function () {
                            that.$processdata.initForm(0)
                        })
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this
                that.getView()
            },
            handleSelectionChange(val){
                let that = this
                that.selectData = []
                for(let i = 0;i<val.length;i++){
                    that.selectData.push(val[i])
                }
                that.btnauthority()
            },
            // 行同意，驳回
            schQuotation(val){
                let that = this
                let datetime = Common.methods.getDatetime()
                let arr = []
                let lan = that.$processdata.getLang()
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        Exclusively_ID: that.selectData[i].LineAuidtIID,
                        MainRelation_IID: that.selectData[i].MainRelation_IID,
                        Relation_IID: that.selectData[i].LineAuidtRelation_IID,
                        Sort: '',
                        userID: that.selectData[i].userid,
                        Audit_Person: that.user,
                        Audit_Status: val,
                        Audit_Date: datetime,
                        Audit_Msg: that.resontxt,
                        LangType: lan
                    }]
                }
                let parm = arr
                that.$http.urlpost('/ISS/PQAudit/ISSQLinesSetStatus', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.CloseDialogVisible = false
                        that.getView()
                    }
                });
            },
            // 驳回
            reject(){
                let that = this
                that.CloseDialogVisible = true
                that.resontxt = ''
            },
            //获取汇率信息
            getExchangeRate(){
                let that = this;
                let time = Common.methods.getDate()
                let datac = [];
                datac.push({
                    query_Condition: ">="+time,
                    query_field_type: 'date',
                    query_field_name: "invalid_date",
                    query_sort: "",
                    row_sign: ""
                });
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    Param: datac
                };
                that.$http.urlpost('Basic/General/GetExchangeRateList', data, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.changeRateArr = res.DataContent;
                    }
                });
            },
            getRiseAndFallRate(data){
                let that = this
                let oldprice = data.Old_Unit_Price;
                let newprice = data.New_Unit_Price;
                let netprice = data.net_price
                for(let i = 0;i<that.changeRateArr.length;i++){
                    if(data.Old_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        oldprice = that.changeRateArr[i].exchange_rate * data.Old_Unit_Price
                    }
                    if(data.New_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        newprice = that.changeRateArr[i].exchange_rate * data.New_Unit_Price
                        netprice = that.changeRateArr[i].exchange_rate * data.net_price
                    }
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) > 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) > 1){
                    return ((( oldprice - newprice)/ newprice * 10000) / 100.00).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) < 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) < 1){
                    return (((oldprice - netprice) / netprice * 10000) / 100.00).toFixed(2)
                }
            },
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
